import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => {
  return <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' fill='none' viewBox='0 0 24 24' {...props} data-sentry-element="svg" data-sentry-component="SvgArrowDown" data-sentry-source-file="ArrowDown.tsx">
            <path fill='currentColor' d='M12 16.8c-.7 0-1.4-.27-1.93-.8L3.55 9.48a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l6.52 6.52c.48.48 1.26.48 1.74 0l6.52-6.52c.29-.29.77-.29 1.06 0s.29.77 0 1.06L13.93 16c-.53.53-1.23.8-1.93.8' data-sentry-element="path" data-sentry-source-file="ArrowDown.tsx" />
        </svg>;
};
export default SvgArrowDown;